import { objectsEqual } from 'src/helpers';

const arrayOfObjectsEqual = (arr1, arr2) =>
  arr1.length === arr2.length && arr1.every((obj, ix) => objectsEqual(obj, arr2[ix]));

export default arrayOfObjectsEqual;
